export default __webpack_public_path__ + "static/media/cert-fsi-cpttm.1429e24e.jpg";